import React from 'react';
import { Tooltip, Typography } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';
import styles from './Content.module.scss';

const { Text } = Typography;

const TextContent = (props) => (
  <Text
    {...props}
    className={styles.text}
  />
);

const ActiveReason = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.changeShutdownReason,
        initialValues: shutdown,
      },
    });
  };

  return (
    <Tooltip
      title={shutdown.alertReason ? 'Изменить' : 'Добавить'}
      placement="topLeft"
    >
      <TextContent onClick={handleClick}>
        {shutdown.alertReason?.name || 'Не указано'}
      </TextContent>
    </Tooltip>
  );
};

const Content = ({ shutdown }) => {
  const { canChange } = useShutdownAccesses();

  if (!canChange) {
    return (
      <TextContent>{shutdown.alertReason?.name || 'Не указано'}</TextContent>
    );
  }

  return <ActiveReason shutdown={shutdown} />;
};

export default Content;
